(function () {
  function isEligible(variant, sellingPlanId) {
    if (!variant || !variant.available || sellingPlanId) return false;
    var report = window.DubiaLowestPriceReport;
    if (!report || !report.prices) return false;
    var approvedPrice = report.prices[String(variant.id)];
    return typeof approvedPrice === 'number' && Number(variant.price) === approvedPrice;
  }

  window.DubiaLowestPrice = {
    isEligible: isEligible,
    update: function (form, variant, sellingPlanId) {
      var message = form.querySelector('[data-product-lowest-price]');
      if (message) message.hidden = !isEligible(variant, sellingPlanId);
    }
  };
})();
